
import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
    fetchCouponsAPI,
    createCouponAPI,
    updateCouponAPI,
    deleteCouponAPI,
} from "../../../Servicefile/Coupnsapis";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import axios from "axios";
// 🎨 ALL STYLE OBJECTS DEFINED OUTSIDE THE COMPONENT
const containerStyle = {
    padding: "15px",
    width: "100%",
    maxWidth: "100%",
    overflowX: "auto",
    boxSizing: "border-box"
};

const headerContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "10px"
};

const addButtonStyle = {
    padding: "10px 20px",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
    fontWeight: "bold",
    fontSize: "14px",
    minWidth: "100px",
    transition: "background-color 0.3s",
    ":hover": {
        backgroundColor: "#9a4bbf"
    }
};

// Desktop Table Styles
const desktopTableContainer = {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch"
};

const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "1200px",
    fontSize: "14px"
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    padding: "12px 8px",
    fontSize: "14px",
    whiteSpace: "nowrap"
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "10px 8px",
    fontSize: "13px",
    wordBreak: "break-word"
};

const actionCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "25px 8px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px"
};

const imageStyle = {
    width: "44px",
    height: "44px",
    objectFit: "cover",
    borderRadius: "6px",
    margin: "0 auto"
};

const editIconStyle = {
    color: "blue",
    cursor: "pointer",
    fontSize: "16px",
    transition: "transform 0.2s",
    ":hover": {
        transform: "scale(1.1)"
    }
};

const deleteIconStyle = {
    color: "red",
    cursor: "pointer",
    fontSize: "16px",
    transition: "transform 0.2s",
    ":hover": {
        transform: "scale(1.1)"
    }
};

// Mobile Card Styles
const mobileCardContainer = {
    display: "none",
    flexDirection: "column",
    gap: "15px"
};

const cardStyle = {
    backgroundColor: "white",
    borderRadius: "10px",
    border: "1px solid #e0e0e0",
    padding: "15px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    transition: "transform 0.2s, box-shadow 0.2s",
    ":hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
    }
};

const cardHeader = {
    marginBottom: "12px",
    paddingBottom: "10px",
    borderBottom: "1px solid #f0f0f0"
};

const cardTitleRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
    flexWrap: "wrap",
    gap: "8px"
};

const cardSerialNo = {
    fontWeight: "bold",
    color: "#666",
    fontSize: "14px"
};

const cardCode = {
    fontWeight: "bold",
    color: "rgb(230 109 51)",
    fontSize: "16px",
    flex: "1",
    textAlign: "center"
};

// Function for card active status
const getCardActiveStatusStyle = (isActive) => ({
    backgroundColor: isActive ? "#28a745" : "#dc3545",
    color: "white",
    padding: "3px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase"
});

const cardSubtitle = {
    color: "#666",
    fontSize: "13px",
    textAlign: "center"
};

const cardContent = {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "15px"
};

const cardImageContainer = {
    display: "flex",
    justifyContent: "center",
    marginBottom: "10px"
};

const cardImageStyle = {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "8px",
    border: "1px solid #e0e0e0"
};

const cardDetailsGrid = {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "10px"
};

const cardDetailItem = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px",
    fontSize: "13px"
};

const cardDetailLabel = {
    fontWeight: "600",
    color: "#555",
    marginRight: "8px"
};

const cardDetailValue = {
    color: "#333",
    fontWeight: "500",
    textAlign: "right",
    wordBreak: "break-word"
};

const cardActions = {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    paddingTop: "10px",
    borderTop: "1px solid #f0f0f0"
};

const cardEditButton = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 15px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    flex: "1",
    ":hover": {
        backgroundColor: "#0056b3"
    }
};

const cardDeleteButton = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 15px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    transition: "background-color 0.3s",
    flex: "1",
    ":hover": {
        backgroundColor: "#c82333"
    }
};

// Modal Styles
const modalOverlay = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    padding: "20px",
    boxSizing: "border-box"
};

const modalContent = {
    backgroundColor: "white",
    padding: "25px",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "500px",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: "0 5px 20px rgba(0,0,0,0.2)"
};

const formGroupStyle = {
    marginBottom: "15px"
};

const formLabelStyle = {
    display: "block",
    marginBottom: "6px",
    fontWeight: "500",
    color: "#555",
    fontSize: "14px"
};

const formInputStyle = {
    width: "100%",
    padding: "10px",
    boxSizing: "border-box",
    borderRadius: "6px",
    border: "1px solid #ddd",
    fontSize: "14px",
    transition: "border-color 0.3s",
    ":focus": {
        outline: "none",
        borderColor: "rgb(230 109 51)"
    }
};

const checkboxGroupStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "20px",
    padding: "10px",
    backgroundColor: "#f8f9fa",
    borderRadius: "6px"
};

const checkboxStyle = {
    width: "18px",
    height: "18px",
    cursor: "pointer"
};

const checkboxLabelStyle = {
    fontSize: "14px",
    fontWeight: "500",
    color: "#555",
    cursor: "pointer"
};

const modalActionsStyle = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginTop: "20px",
    paddingTop: "20px",
    borderTop: "1px solid #eee"
};

const saveButtonStyle = {
    backgroundColor: "#28a745",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    minWidth: "100px",
    transition: "background-color 0.3s",
    ":hover": {
        backgroundColor: "#218838"
    }
};

const closeButtonStyle = {
    backgroundColor: "#6c757d",
    border: "none",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    minWidth: "100px",
    transition: "background-color 0.3s",
    ":hover": {
        backgroundColor: "#5a6268"
    }
};

// Helper function to check if a string is a URL
const isURL = (str) => {
    return str && (str.startsWith('http://') || str.startsWith('https://') || str.startsWith('//'));
};

// Helper function to check if a string is base64
const isBase64 = (str) => {
    return str && (str.startsWith('data:image') || /^[A-Za-z0-9+/]+={0,2}$/.test(str));
};

// Helper function to get image URL correctly
const getImageUrl = (image) => {
    if (!image) return null;

    // Check if it's already a full URL
    if (isURL(image)) {
        return image;
    }

    // Check if it's a base64 string without the data:image prefix
    if (isBase64(image) && !image.startsWith('data:image')) {
        return `data:image/png;base64,${image}`;
    }

    // If it already has data:image prefix, return as-is
    if (image.startsWith('data:image')) {
        return image;
    }

    // Default case: return the image as is (could be a relative URL)
    return image;
};

// Main Component Function
function Foodcoupons() {
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [editId, setEditId] = useState(null);
    const [couponsData, setCouponsData] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [formData, setFormData] = useState({
        offertype: "",
        couponcode: "",
        discountPercentage: "",
        discountAmount: "",
        startdate: "",
        enddate: "",
        vendorId: "",
        active: true,
        image: "",
        discountType: "PERCENTAGE",
        couponType: "FLAT",
        minimumOrderValue: ""
    });

    const today = new Date().toISOString().split("T")[0];

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            showLoader();

            const token = localStorage.getItem("authToken");
            console.log("Token:", token);

            const response = await axios.get(
                "https://backend.maamaas.com/food/api/coupon",
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setCouponsData(response.data);

            console.log("📦 API Data:", response.data);

        } catch (error) {
            console.error("❌ Error fetching coupons:", error);
            alert("Error fetching coupons");
        } finally {
            hideLoader();
        }
    };
    const handleAddRow = () => {
        setFormData({
            offertype: "",
            couponcode: "",
            discountPercentage: "",
            discountAmount: "",
            startdate: "",
            enddate: "",
            vendorId: "",
            active: true,
            image: "",
            discountType: "PERCENTAGE",
            couponType: "FLAT",
            minimumOrderValue: ""
        });
        setImageFile(null);
        setImagePreview(null);
        setEditId(null);
        setIsFormModalOpen(true);
    };

    const handleEditRow = (item) => {
        console.log("📦 Editing item:", item);
        console.log("📦 Item image:", item.image);

        setFormData({
            offertype: item.vendorId === null ? "App_Coupon" : "Vendor_Coupon",
            couponcode: item.code,
            discountPercentage: item.discountType === "PERCENTAGE" ? item.discountPercentage : "",
            discountAmount: item.discountType === "FIXED_AMOUNT" ? item.discountPercentage : "",
            startdate: item.startDate.split("T")[0],
            enddate: item.endDate.split("T")[0],
            vendorId: item.vendorId === null ? "" : item.vendorId,
            active: item.active,
            image: item.image || "", // Store the image as-is from backend
            discountType: item.discountType || "PERCENTAGE",
            couponType: item.couponType || "FLAT",
            minimumOrderValue: item.minimumOrderValue || ""
        });

        // Set image preview using helper function
        if (item.image) {
            const imageUrl = getImageUrl(item.image);
            console.log("📦 Generated image URL for preview:", imageUrl);
            setImagePreview(imageUrl);
        } else {
            setImagePreview(null);
        }

        setImageFile(null);
        setEditId(item.id);
        setIsFormModalOpen(true);
    };

    const handleDeleteRow = async (id) => {
        if (!window.confirm("Are you sure you want to delete this coupon?")) return;
        try {
            await deleteCouponAPI(id);
            alert("✅ Coupon deleted successfully!");
            fetchCoupons();
        } catch (error) {
            console.error("❌ Error deleting coupon:", error);
            alert("❌ Failed to delete coupon");
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);

            // Create preview URL
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleFormSubmit = async () => {
        try {
            // Validate required fields
            if (!formData.couponcode.trim()) {
                alert("Please enter coupon code");
                return;
            }

            // Validate based on discount type
            let discountValue;
            if (formData.discountType === "PERCENTAGE") {
                if (!formData.discountPercentage || parseFloat(formData.discountPercentage) <= 0) {
                    alert("Please enter a valid discount percentage");
                    return;
                }
                discountValue = parseFloat(formData.discountPercentage);
            } else {
                if (!formData.discountAmount || parseFloat(formData.discountAmount) <= 0) {
                    alert("Please enter a valid discount amount");
                    return;
                }
                discountValue = parseFloat(formData.discountAmount);
            }

            // Validate minimum order value for UPTO coupon type
            if (formData.couponType === "UPTO" && (!formData.minimumOrderValue || parseFloat(formData.minimumOrderValue) <= 0)) {
                alert("Please enter a valid minimum order value for UPTO coupon type");
                return;
            }

            // Validate dates
            if (!formData.startdate) {
                alert("Please select start date");
                return;
            }
            if (!formData.enddate) {
                alert("Please select end date");
                return;
            }

            // Prepare coupon data payload
            const couponData = {
                code: formData.couponcode,
                discountPercentage: discountValue,
                startDate: `${formData.startdate}T00:00:00`,
                endDate: `${formData.enddate}T23:59:59`,
                vendorId: formData.vendorId?.trim() === "" ? null : parseInt(formData.vendorId, 10),
                active: formData.active,
                discountType: formData.discountType,
                couponType: formData.couponType,
                minimumOrderValue: formData.couponType === "UPTO" ? parseFloat(formData.minimumOrderValue) : 0,
                usageCount: 0
            };

            console.log("📦 Sending coupon data:", couponData);
            console.log("📦 Image file:", imageFile ? `File: ${imageFile.name}, Size: ${imageFile.size} bytes` : "No image file");

            if (editId) {
                // Update with multipart/form-data
                await updateCouponAPI(editId, couponData, imageFile);
                alert("✅ Coupon updated successfully!");
            } else {
                // Create with multipart/form-data
                await createCouponAPI(couponData, imageFile);
                alert("✅ Coupon created successfully!");
            }

            setIsFormModalOpen(false);
            setEditId(null);
            setImageFile(null);
            setImagePreview(null);
            fetchCoupons();
        } catch (error) {
            console.error("❌ Error saving coupon:", error);
            alert(`❌ Failed to save coupon: ${error.message || "Please check console for details"}`);
        }
    };

    const handleModalClose = () => {
        setIsFormModalOpen(false);
        setImageFile(null);
        setImagePreview(null);
    };

    const getDiscountLabel = () => {
        return formData.discountType === "PERCENTAGE" ? "Discount (%)" : "Discount Amount (₹)";
    };

    const getDiscountValue = () => {
        return formData.discountType === "PERCENTAGE" ? formData.discountPercentage : formData.discountAmount;
    };

    const handleDiscountChange = (e) => {
        const { value } = e.target;
        if (formData.discountType === "PERCENTAGE") {
            setFormData(prev => ({ ...prev, discountPercentage: value }));
        } else {
            setFormData(prev => ({ ...prev, discountAmount: value }));
        }
    };

    return (
        <div style={containerStyle}>
            <div style={headerContainerStyle}>
                <button onClick={handleAddRow} style={addButtonStyle}>Add+</button>
            </div>

            {/* Desktop Table View */}
            <div style={{
                ...desktopTableContainer,
                display: window.innerWidth > 768 ? 'block' : 'none'
            }}>
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={tableHeaderStyle}>S.No</th>
                            <th style={tableHeaderStyle}>Offer Type</th>
                            <th style={tableHeaderStyle}>Code</th>
                            <th style={tableHeaderStyle}>Image</th>
                            <th style={tableHeaderStyle}>Discount</th>
                            <th style={tableHeaderStyle}>Discount Type</th>
                            <th style={tableHeaderStyle}>Coupon Type</th>
                            <th style={tableHeaderStyle}>Min Order</th>
                            <th style={tableHeaderStyle}>Start Date</th>
                            <th style={tableHeaderStyle}>End Date</th>
                            <th style={tableHeaderStyle}>Active</th>
                            <th style={tableHeaderStyle}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {couponsData.map((item, index) => {
                            const imageUrl = getImageUrl(item.image);

                            return (
                                <tr key={item.id}>
                                    <td style={tableCellStyle}>{index + 1}</td>

                                    {/* ✅ Dynamic Offer Type */}
                                    <td style={tableCellStyle}>
                                        {item.vendorId === null ? "SuperAdmin_Coupon" : "Vendor_Coupon"}
                                    </td>

                                    <td style={tableCellStyle}>{item.code}</td>

                                    <td style={tableCellStyle}>
                                        {item.image ? (
                                            <img src={imageUrl} alt="Coupon" style={imageStyle} />
                                        ) : (
                                            "No Image"
                                        )}
                                    </td>

                                    <td style={tableCellStyle}>{item.discountPercentage}</td>
                                    <td style={tableCellStyle}>{item.discountType}</td>
                                    <td style={tableCellStyle}>{item.couponType}</td>
                                    <td style={tableCellStyle}>{item.minimumOrderValue}</td>

                                    {/* ✅ Safe date handling */}
                                    <td style={tableCellStyle}>
                                        {item.startDate ? item.startDate.split('T')[0] : "-"}
                                    </td>
                                    <td style={tableCellStyle}>
                                        {item.endDate ? item.endDate.split('T')[0] : "-"}
                                    </td>

                                    <td style={tableCellStyle}>
                                        {item.active ? "Yes" : "No"}
                                    </td>

                                    <td style={actionCellStyle}>
                                        <FaEdit onClick={() => handleEditRow(item)} />
                                        <FaTrash onClick={() => handleDeleteRow(item.id)} />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Mobile Card View */}
            <div style={{
                ...mobileCardContainer,
                display: window.innerWidth <= 768 ? 'flex' : 'none'
            }}>
                {couponsData
                    .filter((item) => item.vendorId === null)
                    .map((item, index) => {
                        const imageUrl = getImageUrl(item.image);
                        return (
                            <div key={item.id} style={cardStyle}>
                                <div style={cardHeader}>
                                    <div style={cardTitleRow}>
                                        <span style={cardSerialNo}>{index + 1}.</span>
                                        <span style={cardCode}>{item.code}</span>
                                        <span style={getCardActiveStatusStyle(item.active)}>
                                            {item.active ? "Active" : "Inactive"}
                                        </span>
                                    </div>
                                    <div style={cardSubtitle}>App_Coupon</div>
                                </div>

                                <div style={cardContent}>
                                    {item.image && (
                                        <div style={cardImageContainer}>
                                            <img
                                                src={imageUrl}
                                                alt="Coupon"
                                                style={cardImageStyle}
                                                onError={(e) => {
                                                    console.error(`❌ Error loading image for coupon ${item.code}:`, item.image);
                                                    e.target.style.display = 'none';
                                                }}
                                            />
                                        </div>
                                    )}

                                    <div style={cardDetailsGrid}>
                                        <div style={cardDetailItem}>
                                            <span style={cardDetailLabel}>Coupon Type:</span>
                                            <span style={cardDetailValue}>{item.couponType}</span>
                                        </div>
                                        <div style={cardDetailItem}>
                                            <span style={cardDetailLabel}>Discount:</span>
                                            <span style={cardDetailValue}>{item.discountPercentage}</span>
                                        </div>
                                        <div style={cardDetailItem}>
                                            <span style={cardDetailLabel}>Discount Type:</span>
                                            <span style={cardDetailValue}>{item.discountType}</span>
                                        </div>
                                        <div style={cardDetailItem}>
                                            <span style={cardDetailLabel}>Min Order:</span>
                                            <span style={cardDetailValue}>{item.minimumOrderValue}</span>
                                        </div>
                                        <div style={cardDetailItem}>
                                            <span style={cardDetailLabel}>Start:</span>
                                            <span style={cardDetailValue}>{item.startDate.split('T')[0]}</span>
                                        </div>
                                        <div style={cardDetailItem}>
                                            <span style={cardDetailLabel}>End:</span>
                                            <span style={cardDetailValue}>{item.endDate.split('T')[0]}</span>
                                        </div>
                                    </div>
                                </div>

                                <div style={cardActions}>
                                    <button
                                        onClick={() => handleEditRow(item)}
                                        style={cardEditButton}
                                        aria-label="Edit"
                                    >
                                        <FaEdit style={{ marginRight: '6px' }} />
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => handleDeleteRow(item.id)}
                                        style={cardDeleteButton}
                                        aria-label="Delete"
                                    >
                                        <FaTrash style={{ marginRight: '6px' }} />
                                        Delete
                                    </button>
                                </div>
                            </div>
                        );
                    })}
            </div>

            {isFormModalOpen && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3 style={{ color: "rgb(230 109 51)", marginBottom: "20px", textAlign: "center" }}>
                            {editId ? "Edit Coupon" : "Add Coupon"}
                        </h3>

                        {/* Image Preview */}
                        {imagePreview && (
                            <div style={{ marginBottom: "15px", textAlign: "center" }}>
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "150px",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd",
                                        marginBottom: "10px"
                                    }}
                                />
                                <p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
                                    {imageFile ? `Selected: ${imageFile.name}` : "Existing image"}
                                </p>
                            </div>
                        )}

                        {/* Coupon Code Field */}
                        <div style={formGroupStyle}>
                            <label style={formLabelStyle}>Coupon Code *</label>
                            <input
                                type="text"
                                name="couponcode"
                                value={formData.couponcode}
                                onChange={handleChange}
                                style={formInputStyle}
                                placeholder="Enter coupon code"
                                required
                            />
                        </div>

                        {/* Coupon Type Selection */}
                        <div style={formGroupStyle}>
                            <label style={formLabelStyle}>Coupon Type:</label>
                            <select
                                name="couponType"
                                value={formData.couponType}
                                onChange={handleChange}
                                style={formInputStyle}
                            >
                                <option value="FLAT">Flat</option>
                                <option value="UPTO">Upto</option>
                            </select>
                        </div>

                        {/* Minimum Order Value (only shown for UPTO coupon type) */}
                        {formData.couponType === "UPTO" && (
                            <div style={formGroupStyle}>
                                <label style={formLabelStyle}>Minimum Order Value (₹):</label>
                                <input
                                    type="number"
                                    name="minimumOrderValue"
                                    value={formData.minimumOrderValue}
                                    onChange={handleChange}
                                    min="0"
                                    step="1"
                                    style={formInputStyle}
                                    placeholder="Enter minimum order value"
                                />
                            </div>
                        )}

                        {/* Discount Type Selection */}
                        <div style={formGroupStyle}>
                            <label style={formLabelStyle}>Discount Type:</label>
                            <select
                                name="discountType"
                                value={formData.discountType}
                                onChange={handleChange}
                                style={formInputStyle}
                            >
                                <option value="PERCENTAGE">Percentage</option>
                                <option value="FIXED_AMOUNT">Fixed Amount</option>
                            </select>
                        </div>

                        {/* Discount Field (changes based on discount type) */}
                        <div style={formGroupStyle}>
                            <label style={formLabelStyle}>{getDiscountLabel()} *</label>
                            <input
                                type="number"
                                value={getDiscountValue()}
                                onChange={handleDiscountChange}
                                min="0"
                                step={formData.discountType === "PERCENTAGE" ? "0.01" : "1"}
                                style={formInputStyle}
                                placeholder={formData.discountType === "PERCENTAGE" ? "Enter percentage" : "Enter amount"}
                                required
                            />
                        </div>

                        <div style={formGroupStyle}>
                            <label style={formLabelStyle}>Start Date *</label>
                            <input
                                type="date"
                                name="startdate"
                                value={formData.startdate}
                                onChange={handleChange}
                                min={today}
                                style={formInputStyle}
                                required
                            />
                        </div>

                        <div style={formGroupStyle}>
                            <label style={formLabelStyle}>End Date *</label>
                            <input
                                type="date"
                                name="enddate"
                                value={formData.enddate}
                                onChange={handleChange}
                                min={formData.startdate || today}
                                style={formInputStyle}
                                required
                            />
                        </div>

                        <div style={formGroupStyle}>
                            <label style={formLabelStyle}>Coupon Image:</label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={formInputStyle}
                            />
                            <small style={{ color: "#666", fontSize: "12px", display: "block", marginTop: "5px" }}>
                                {editId ? "Leave empty to keep existing image" : "Optional"}
                            </small>
                        </div>

                        <div style={checkboxGroupStyle}>
                            <input
                                type="checkbox"
                                name="active"
                                id="activeCheckbox"
                                checked={formData.active}
                                onChange={handleChange}
                                style={checkboxStyle}
                            />
                            <label htmlFor="activeCheckbox" style={checkboxLabelStyle}>
                                {formData.active ? "Active" : "Inactive"}
                            </label>
                        </div>

                        <div style={modalActionsStyle}>
                            <button onClick={handleFormSubmit} style={saveButtonStyle}>
                                {editId ? "Update" : "Save"}
                            </button>
                            <button onClick={handleModalClose} style={closeButtonStyle}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Foodcoupons;